import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import { TRYOUT } from "../mock";

// Sticky bottom bar shown only on mobile: $99 tryout + free first class, one tap away.
const StickyTrialBar = () => {
  const { pathname } = useLocation();
  const hide = pathname.startsWith("/trial") || pathname.startsWith("/tryout") || pathname.startsWith("/admin");
  if (hide) return null;

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur border-t border-neutral-200 px-4 py-2.5 pb-[max(0.625rem,env(safe-area-inset-bottom))]" data-testid="sticky-bar">
      <div className="flex items-center gap-2">
        <Link to="/tryout" className="flex-1" data-testid="sticky-tryout-btn">
          <span className="flex items-center justify-center rounded-full bg-br-yellow text-[#1A1A1A] font-extrabold text-sm px-3 py-2.5 shadow-sm">
            {TRYOUT.price} Tryout
          </span>
        </Link>
        <Link to="/trial" className="flex-1" data-testid="sticky-free-class-btn">
          <span className="flex items-center justify-center gap-1.5 rounded-full bg-br-green text-white font-semibold text-sm px-3 py-2.5 shadow-sm">
            <CalendarCheck size={15} /> Free Class
          </span>
        </Link>
      </div>
    </div>
  );
};

export default StickyTrialBar;
